export const createPaymentFormSearchParams = (
  formData: Record<string, unknown>,
): URLSearchParams => {
  const searchParams = new URLSearchParams();
  const queryParams = {
    plan: formData.selectedPlan,
    org: formData.organizationName,
    email: formData.referenceEmail,
    months: formData.selectedMonth,
    users: formData.maxUserCount,
    start: formData.startDate,
    skip:
      formData.skipOrganizationName === undefined
        ? undefined
        : String(formData.skipOrganizationName),
  };

  Object.entries(queryParams).forEach(([key, value]) => {
    if (value != null) searchParams.set(key, String(value));
  });

  return searchParams;
};
